import Style from "../../verifications.module.scss";

const Services = ({ state }) => {
  // const color = state?.pendingData?.item_grading?.filter((val)=> val?.type === "Color")?.[0]

  // FIXME Aswin  : upadate the qc fields
  const getGradingValue = (type) => {
    return (
      state?.pendingData?.item_grading?.find((item) => item?.type === type)
        ?.name ?? "--"
    );
  };
  return (
    <div className={`${Style.multicolumn_table}`}>
      <h6 className="pro-ttl h6 pro-mb-2">Services</h6>
      <table>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>Service Type</td>
            <td>
              <div className="pro-d-flex pro-flex-wrap pro-gap-2">
                {state?.pendingData?.service?.map((item, index) => (
                  <p key={index} className="pro-mb-0">
                    {item?.name ?? "--"}
                    {index !== state.pendingData.service.length - 1 && (
                      <span>,</span>
                    )}
                  </p>
                ))}
              </div>
            </td>
          </tr>
          <tr>
            <td>Color</td>
            <td>{getGradingValue("Color")}</td>
          </tr>
          <tr>
            <td>Clarity</td>
            <td>{getGradingValue("Clarity")}</td>
          </tr>
          <tr>
            <td>Cut</td>
            <td>{getGradingValue("Cut")}</td>
          </tr>
          <tr>
            <td>Finish</td>
            <td>{getGradingValue("Finish")}</td>
          </tr>
          <tr>
            <td>Grade</td>
            <td>
              {state?.pendingData?.grade
                ? state?.pendingData?.grade.map((val) => val?.name).join(", ")
                : "--"}
            </td>
          </tr>
          <tr>
            <td>Packaging Type</td>
            <td>{state?.pendingData?.packing_type?.packing_type ?? "--"}</td>
          </tr>
          <tr>
            <td>Box Weight</td>
            <td>{state?.pendingData?.box_weight ?? "--"}</td>
          </tr>
          <tr>
            <td>Certificate Type</td>
            <td>{state?.pendingData?.certificate_type ?? "--"}</td>
          </tr>
          <tr>
            <td>Prepared By</td>
            <td>{state?.pendingData?.prepared_by ?? "--"}</td>
          </tr>
          <tr>
            <td>Payment Mode</td>
            <td>{state?.pendingData?.payment_mode ?? "--"}</td>
          </tr>
          <tr>
            <td>Additional Document</td>
            <td>{state?.pendingData?.additional_document ?? "--"}</td>
          </tr>
          <tr>
            <td>Remarks</td>
            <td>{state?.pendingData?.remarks ?? "--"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Services;
